<template>
  <div>
    <mdb-row>
      <mdb-col md="3" style="font-size:14px; overflow:auto">
        <subject-select :trainingId="trainingId" v-model="subject"/>
      </mdb-col>
      <mdb-col md="9" v-if="subject" >
        <div class="title"><mdb-icon icon="chalkboard-teacher" /> 과목명: {{subject.name}}</div>
        <subject-plan :plan="subject.plan" :lectures="subject.lectures"/>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import SubjectPlan from './SubjectPlan.vue';
import SubjectSelect from './SubjectSelect.vue';
export default {
  name: 'SubjectsPlan',
  components: { SubjectPlan, SubjectSelect },
  props: ['trainingId'],
  data: () => ({
    TAG: 'SubjectsPlan :',
    subject: undefined
  })
}
</script>
